import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { DatoAdjuntoModel } from "src/app/shared/models/dato-adjunto.model";
import { Subscription } from "rxjs";
import OtrasSolicitudesService from "./otras-solicitudes.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { AuthService } from "src/app/shared/services/auth.service";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";
import { NgbCalendar, NgbDate, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertsService } from "src/app/shared/services/alerts.service";
import { AlertType } from "src/app/shared/models/alert.model";
import { SolicitudService } from "../solicitudes/solicitud.service";
import { environment } from "../../../../../../../environments/environment";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
// tslint:disable-next-line:max-line-length
import { ModalConfirmacionSolicitudComponent } from "src/app/components/core/layouts/modal-confirmacion-solicitud/modal-confirmacion-solicitud.component";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { HttpEventType } from "@angular/common/http";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { ModalAceptarTerminosComponent } from "src/app/components/core/layouts/modal-aceptar-terminos/modal-aceptar-terminos.component";
import { EstadosRnt } from "src/app/shared/enumeraciones/estados-rnt.enum";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
  TipoConfirmacionModalType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { ModalInfoEliminarActividadEconomica } from "src/app/components/core/layouts/modal-info-eliminar/modal-info-eliminar-actividad-economica.component";

import { RNTPrestadorModel } from "src/app/shared/models/rnt-prestador.models";
import {
  AccionesPagoFonturRntEntry,
  ValidarPagoFonturResponse,
} from "src/app/shared/entrys/aciones-pago-fontur-rnt.entry";
import { TestadoPagoFotnur , TestadoTextoPagoFontur} from "src/app/shared/enumeraciones/estado-pagoFontur-rnt.enum";

@Component({
  selector: "app-otras-solicitudes",
  templateUrl: "./otras-solicitudes.component.html",
  styleUrls: ["./otras-solicitudes.component.scss"],
})
export class OtrasSolicitudesComponent implements OnInit, OnDestroy {
  maxDateValidation: NgbDate = new NgbDate(
    this.calendar.getToday().year + 1,
    this.calendar.getToday().month,
    this.calendar.getToday().day
  );
  tipo_suspencion = TipoSolicitud.Suspension;
  tipo_cancelacion = TipoSolicitud.Cancelacion;
  tipo_reactivacion = TipoSolicitud.Reactivacion;
  estado_en_proceso = EstadosSolicitud.EnProceso;
  si_pago = TestadoPagoFotnur.pago;
  no_pago = TestadoPagoFotnur.nopago;
  paga_manual = TestadoTextoPagoFontur.pagoManual;
  pago_sin_estado = TestadoPagoFotnur.SinEstado;
  estado_suspendido_por_no_renovar = EstadosRnt.SuspendidoPorNoRenovar;
  tipo_guia = TipoRnt.Guia;
  tipo_inmueble = TipoRnt.Inmuebles;
  tipo_establecimiento = TipoRnt.Establecimiento;
  rol_guia = false;
  datos_adjuntos: Array<DatoAdjuntoModel>;
  subscription: Subscription;
  completaForm: FormGroup;
  dataShared: DatoSolicitudSharedModel;
  rntPrestadorEntry: RNTPrestadorModel;
  headers: Array<string>;
  pasoActual: number;
  totalPasos: Array<number>;
  extensiones = [
    "application/pdf",
    "image/jpg",
    "image/x-png",
    "image/png",
    "image/jpeg",
  ];
  private AMAZON_IMAGEN;
  texto_aceptacion_terminos: string = "";
  omitir_documentos = false;
  result_pago_fontur: AccionesPagoFonturRntEntry;

  public Texto_Reactivacion_renovacion1: string = "";
  public Texo_Mensaje_estado_fontur: string = "";
  public valorFormaPagoFontur:string ="";


  constructor(
    private router: Router,
    private dataSharedService: DataSharedService,
    private otrasSolicitudesService: OtrasSolicitudesService,
    private formBuilder: FormBuilder,
    private solicitudService: SolicitudService,
    private authService: AuthService,
    public calendar: NgbCalendar,
    private alertService: AlertsService,
    public ayudaService: AyudasService,
    private modalService: NgbModal,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.dataShared = {} as DatoSolicitudSharedModel;
    this.result_pago_fontur = {} as AccionesPagoFonturRntEntry;
    this.headers = ["Nombre"];
    this.rol_guia = authService.getRolDetalleUser() === TipoPrestador.Guia;
    this.subscription = this.dataSharedService.data$.subscribe((dataShared) => {
      this.dataShared = dataShared;
      if (!this.dataShared.tipo_solicitud) {
        this.router.navigate(["/mis-establecimientos"]);
      }
      this.completaForm = this.formBuilder.group({
        solicitud_id: ["", Validators.required],
        fecha_inicio_suspension: [new Date(Date.now()), Validators.required],
        fecha_fin_suspension: ["", Validators.required],
        observaciones: ["", Validators.required],
      });
    });
    this.AMAZON_IMAGEN = enviromentGlobalService.amazonImage;
  }

  ngOnInit() {
    this.totalPasos = Array<number>(0);
    this.selectTipeSolicitud();
  }

  async selectTipeSolicitud() {
    if (
      this.dataShared.data &&
      this.dataShared.estado_solicitud === EstadosSolicitud.EnProceso
    ) {
      switch (this.dataShared.tipo_solicitud) {
        case TipoSolicitud.Suspension:
          this.completaForm = this.formBuilder.group({
            solicitud_id: [
              this.dataShared.data.solicitud_id,
              Validators.required,
            ],
            fecha_inicio_suspension: [
              new Date(Date.now()),
              Validators.required,
            ],
            fecha_fin_suspension: ["", Validators.required],
            observaciones: ["", Validators.required],
          });
          break;
        case TipoSolicitud.Cancelacion:
          this.completaForm = this.formBuilder.group({
            solicitud_id: [
              this.dataShared.data.solicitud_id,
              Validators.required,
            ],
            observaciones: ["", Validators.required],
          });
          break;
        case TipoSolicitud.Reactivacion:
          if (
            this.dataShared.data.estado_rnt_id ==
            EstadosRnt.SuspendidoPorNoRenovar
          ) {
            this.rntPrestadorEntry = this.dataShared.data;
            this.totalPasos = Array<number>(6);
            this.pasoActual = 1;
          }
          if (!this.dataShared.data.es_devuelta) {
            this.otrasSolicitudesService
              .createReactivacion(this.dataShared.data)
              .subscribe((resultado) => {
                if (resultado.result) {
                  this.createReactivacionAccion(resultado);
                } else {
                  this.router.navigate(["/mis-establecimientos"]);
                }
              });
          } else {

            this.solicitudService
              .get(this.dataShared.data)
              .subscribe(async (resultado) => {
                try {
                  if (resultado.result) {
                    this.createReactivacionAccion(resultado);
                    this.otrasSolicitudesService
                      .getDocumentoReactivacion(resultado.data)
                      .subscribe((resultadoDocu) => {
                        if (resultadoDocu.result) {
                          if (resultadoDocu.data) {
                            (resultadoDocu.data as Array<any>).forEach(
                              (dato) => {
                                if (!this.datos_adjuntos) {
                                  this.datos_adjuntos =
                                    new Array<DatoAdjuntoModel>();
                                }

                                if (dato.nombre_archivo && dato.ruta_url) {
                                  const archivo = {
                                    nombre: dato.nombre_archivo,
                                    ruta_url: dato.ruta_url,
                                  } as any;
                                  this.datos_adjuntos.push({
                                    ...archivo,
                                    porcentaje_cargado: 100,
                                  } as DatoAdjuntoModel);
                                }
                              }
                            );
                          }
                        }
                      });

                    this.otrasSolicitudesService
                      .getOmitirDocumento(this.dataShared.data)
                      .subscribe((resultadoOmDocu) => {
                        if (resultadoOmDocu.result) {
                          this.omitir_documentos =
                            resultadoOmDocu.data as boolean;
                        }
                      });


                   // validar metodo de pago
                    await this.ValidarOpcionPago();

                    if(this.valorFormaPagoFontur===this.paga_manual){

                      this.showsTextReactivacionRenovacion2();

                    } else {

                        // validar pago
                        await this.validarPagoFontur(
                          Number(this.rntPrestadorEntry.codigo_rnt),Number(resultado.data.solicitud_id)
                        )
                          .then((result_pago_fontur) => {
                            this.showsTextReactivacionRenovacion(
                              result_pago_fontur.estado_pago_fontur_id,
                              result_pago_fontur.payment_status
                            );
                          })
                          .catch((error) => {
                            console.error("Error al validar el pago:", error);
                            this.showsTextReactivacionRenovacion(
                              this.result_pago_fontur.estado_pago_fontur_id,
                              this.result_pago_fontur.payment_status
                            );
                          });
                    }
                    // actualizar condicion de pago Fontur
                    if (this.result_pago_fontur.payment_status === "paid") {
                      this.ActualizarEstadoPagoFontur(
                        Number(this.rntPrestadorEntry.codigo_rnt),
                        this.si_pago,
                        this.result_pago_fontur.query_date
                      );
                    } else {
                      this.ActualizarEstadoPagoFontur(
                        Number(this.rntPrestadorEntry.codigo_rnt),
                        this.no_pago,
                        this.result_pago_fontur.query_date
                      );
                    }
                  }
                } catch (error) {
                  this.router.navigate(["mis-establecimientos"]);
                }
              });
          }

          break;
        default:
          this.router.navigate(["mis-establecimientos"]);
          break;
      }
    } else {
      switch (this.dataShared.tipo_solicitud) {
        case TipoSolicitud.Suspension:
          this.completaForm = this.formBuilder.group({
            fecha_inicio_suspension: [
              new Date(Date.now() + 1),
              Validators.required,
            ],
            fecha_fin_suspension: ["", Validators.required],
            observaciones: ["", Validators.required],
          });
          // this.completaForm.controls['fecha_inicio_suspension'].disable();
          break;
        case TipoSolicitud.Cancelacion:
          this.completaForm = this.formBuilder.group({
            observaciones: ["", Validators.required],
          });
          break;
        case TipoSolicitud.Reactivacion:
          if (
            this.dataShared.data.estado_rnt_id ==
            EstadosRnt.SuspendidoPorNoRenovar
          ) {
            this.rntPrestadorEntry = this.dataShared.data;
            this.totalPasos = Array<number>(6);
            this.pasoActual = 1;
          }

          if (!this.dataShared.data.es_devuelta) {

            // mostrar informacion primera vez

            // crear reactivacion solicitud
            this.otrasSolicitudesService
              .createReactivacion(this.dataShared.data)
              .subscribe( async(resultado) =>
              {
                  if (resultado.result){

                    // validar formulario
                    this.createReactivacionAccion(resultado);

                    // validar metodo de pago
                    await this.ValidarOpcionPago();

                    if(this.valorFormaPagoFontur===this.paga_manual){

                      this.showsTextReactivacionRenovacion2();

                    } else {

                      // validar pago servicio fontur (Automatico)
                      await this.validarPagoFontur(
                        Number(this.rntPrestadorEntry.codigo_rnt),Number(resultado.data.solicitud_id)
                      )
                        .then((result_pago_fontur) => {
                          this.showsTextReactivacionRenovacion(
                            result_pago_fontur.estado_pago_fontur_id,
                            result_pago_fontur.payment_status
                          );
                        })
                        .catch((error) => {
                          console.error("Error al validar el pago:", error);
                          this.showsTextReactivacionRenovacion(
                            this.result_pago_fontur.estado_pago_fontur_id,
                            this.result_pago_fontur.payment_status
                          );
                        });
                   }

                  // actualizar condicion de pago Fontur
                        if (this.result_pago_fontur.payment_status === "paid") {
                          this.ActualizarEstadoPagoFontur(
                            Number(this.rntPrestadorEntry.codigo_rnt),
                            this.si_pago,
                            this.result_pago_fontur.query_date
                          );

                        }else if (this.valorFormaPagoFontur===this.paga_manual){

                          this.ActualizarEstadoPagoFontur(
                            Number(this.rntPrestadorEntry.codigo_rnt),
                            this.si_pago,
                            this.result_pago_fontur.query_date
                          );

                        } else {
                          this.ActualizarEstadoPagoFontur(
                            Number(this.rntPrestadorEntry.codigo_rnt),
                            this.no_pago,
                            this.result_pago_fontur.query_date
                          );
                        }

                } else {
                  this.router.navigate(["/mis-establecimientos"]);
                }
              });


          } else {

          await this.metodoAsync();

            this.solicitudService
                .get(this.dataShared.data)
                  .subscribe(async (resultado) => {

                    try {
                      if (resultado.result) {
                        this.createReactivacionAccion(resultado);
                        this.otrasSolicitudesService
                          .getDocumentoReactivacion({
                            detalle_solicitud_id:
                              resultado.data.detalle_solicitud_id,
                            ...this.dataShared.data,
                          })
                          .subscribe((resultadoDocu) => {
                            if ( resultadoDocu.result) {
                              if (resultadoDocu.data) {
                                (resultadoDocu.data as Array<any>).forEach(
                                  (dato) => {
                                    if (!this.datos_adjuntos) {
                                      this.datos_adjuntos =
                                        new Array<DatoAdjuntoModel>();
                                    }

                                    if (dato.nombre_archivo && dato.ruta_url) {
                                      const archivo = { nombre: dato.nombre_archivo,  ruta_url: dato.ruta_url,
                                      } as any;
                                      this.datos_adjuntos.push({
                                        ...archivo,
                                        porcentaje_cargado: 100,
                                      } as DatoAdjuntoModel);
                                    }

                                  }
                                );
                              }
                            }
                          });
                      }
                    } catch (e) {
                      console.log(e);
                    }
                  });
          }
          break;
        default:
          this.router.navigate(["mis-establecimientos"]);
          break;
      }
    }
  }

  createReactivacionAccion(resultado?: any): void {
    this.completaForm = this.formBuilder.group({
      solicitud_id: [resultado.data.solicitud_id, Validators.required],
      detalle_solicitud_id: [
        resultado.data.detalle_solicitud_id,
        Validators.required,
      ],
      observaciones: [
        resultado.data.observaciones_prestador,
        Validators.required,
      ],
    });
    this.otrasSolicitudesService
      .getOmitirDocumento(this.dataShared.data)
      .subscribe((resultadoOmDocu) => {
        if (resultadoOmDocu.result) {
          this.omitir_documentos = resultadoOmDocu.data as boolean;
        }
      });
  }
  onUpdate() {
    this.otrasSolicitudesService
      .getParametro({
        parametro_id: "INDICADOR_MOSTRAR_TRATAMIENTO_DATOS_SOLICITUD",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          if (resultado.data) {
            if (this.dataShared.tipo_solicitud === TipoSolicitud.Cancelacion) {
              this.showModalInfoEliminarActividadEconomica();
            } else {
              this.showModalAceptarTermino();
            }
          } else {
            this.continuarPaso();
          }
        } else {
          this.router.navigate(["/mis-establecimientos"]);
        }
      });
  }

  continuarPaso() {
    switch (this.dataShared.tipo_solicitud) {
      case TipoSolicitud.Suspension:
        this.dataShared.data.fecha_inicio_suspension =
          this.completaForm.controls["fecha_inicio_suspension"].value;
        this.dataShared.data.fecha_fin_suspension =
          this.completaForm.controls["fecha_fin_suspension"].value;
        this.otrasSolicitudesService
          .createSuspension(this.dataShared.data)
          .subscribe((resultado) => {
            if (resultado.result) {
              this.otrasSolicitudesService
                .update({
                  ...this.completaForm.value,
                  observaciones: this.completaForm.value.observaciones.replace(
                    new RegExp("\r?\n", "g"),
                    "<br />"
                  ),
                  rnt_id: this.dataShared.data.rnt_id,
                  solicitud_id: resultado.data.solicitud_id,
                  codigo_camara: this.dataShared.data.codigo_camara,
                  estado_solicitud_id: this.estado_en_proceso,
                  paso_solicitud_id: 1,
                  tipo_solicitud_id: this.dataShared.tipo_solicitud,
                })
                .subscribe((resultadoUpd) => {
                  if (resultadoUpd.result) {
                    this.otrasSolicitudesService
                      .sendNotificar({
                        ...resultadoUpd.data,
                        rnt_id: this.dataShared.data.rnt_id,
                        municipio_id: this.dataShared.data.municipio_id,
                      })
                      .subscribe((resultadoNotifica) => {
                        if (resultadoNotifica.result) {
                          const modalFinalizar = this.modalService.open(
                            ModalConfirmacionSolicitudComponent,
                            { centered: true }
                          );
                          modalFinalizar.componentInstance.mensaje =
                            resultadoNotifica.data;
                          modalFinalizar.result
                            .then(() => {
                              this.router.navigate(["/mis-establecimientos"]);
                            })
                            .catch(() => {
                              this.router.navigate(["/mis-establecimientos"]);
                            });
                        }
                      });
                  }
                });
            }
          });
        break;
      case TipoSolicitud.Cancelacion:
        this.otrasSolicitudesService
          .createCancelacion(this.dataShared.data)
          .subscribe((resultado) => {
            if (resultado.result) {
              this.otrasSolicitudesService
                .update({
                  ...this.completaForm.value,
                  observaciones: this.completaForm.value.observaciones.replace(
                    new RegExp("\r?\n", "g"),
                    "<br />"
                  ),
                  rnt_id: this.dataShared.data.rnt_id,
                  solicitud_id: resultado.data.solicitud_id,
                  codigo_camara: this.dataShared.data.codigo_camara,
                  estado_solicitud_id: this.estado_en_proceso,
                  paso_solicitud_id: 1,
                  tipo_solicitud_id: this.dataShared.tipo_solicitud,
                })
                .subscribe((resultadoUpd) => {
                  if (resultadoUpd.result) {
                    this.otrasSolicitudesService
                      .sendNotificar({
                        ...resultadoUpd.data,
                        rnt_id: this.dataShared.data.rnt_id,
                        municipio_id: this.dataShared.data.municipio_id,
                      })
                      .subscribe((resultadoNotifica) => {
                        if (resultadoNotifica.result) {
                          const modalFinalizar = this.modalService.open(
                            ModalConfirmacionSolicitudComponent,
                            { centered: true }
                          );
                          modalFinalizar.componentInstance.mensaje =
                            resultadoNotifica.data;
                          modalFinalizar.result
                            .then(() => {
                              this.router.navigate(["/mis-establecimientos"]);
                            })
                            .catch(() => {
                              this.router.navigate(["/mis-establecimientos"]);
                            });
                        }
                      });
                  }
                });
            } else {
              this.router.navigate(["/mis-establecimientos"]);
            }
          });
        break;
      case TipoSolicitud.Reactivacion:
        if (this.dataShared.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar) {

          //confirmacion pago automatico fontur...
       if (this.result_pago_fontur.estado_pago_fontur_id == this.si_pago && this.result_pago_fontur.payment_status == "paid" )
          {

            this.otrasSolicitudesService
              .update({
                ...this.completaForm.value,
                mensaje_pago_fontur: this.Texo_Mensaje_estado_fontur,
                rnt_id: this.dataShared.data.rnt_id,
                codigo_camara: this.dataShared.data.codigo_camara,
                estado_solicitud_id: this.estado_en_proceso,
                paso_solicitud_id: 1,
                tipo_solicitud_id: this.dataShared.tipo_solicitud,
              })
              .subscribe((response) => {
                this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                  ...this.dataShared,
                  data: {
                    ...this.dataShared.data,
                    ...this.completaForm.getRawValue(),
                  },
                });
                this.router.navigate(["solicitud"]);
              }),
              (error) => this.router.navigate(["solicitud"]);

          } else {

            //confirmacion  pago manual fontur...
            this.otrasSolicitudesService
              .update({
                ...this.completaForm.value,
                observaciones_prestador:
                  this.completaForm.value.observaciones.replace(
                    new RegExp("\r?\n", "g"),
                    "<br />"
                  ),
                rnt_id: this.dataShared.data.rnt_id,
                codigo_camara: this.dataShared.data.codigo_camara,
                estado_solicitud_id: this.estado_en_proceso,
                paso_solicitud_id: 1,
                tipo_solicitud_id: this.dataShared.tipo_solicitud,
              })
              .subscribe((response) => {
                this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                  ...this.dataShared,
                  data: {
                    ...this.dataShared.data,
                    ...this.completaForm.getRawValue(),
                  },
                });
                this.router.navigate(["solicitud"]);
              }),
              (error) => this.router.navigate(["solicitud"]);
          }
        } else {
          this.otrasSolicitudesService
            .update({
              ...this.completaForm.value,
              observaciones: this.completaForm.value.observaciones.replace(
                new RegExp("\r?\n", "g"),
                "<br />"
              ),
              rnt_id: this.dataShared.data.rnt_id,
              codigo_camara: this.dataShared.data.codigo_camara,
              estado_solicitud_id: this.estado_en_proceso,
              paso_solicitud_id: 1,
              tipo_solicitud_id: this.dataShared.tipo_solicitud,
            })
            .subscribe((resultado) => {
              if (resultado.result) {
                this.otrasSolicitudesService
                  .sendNotificar({
                    ...resultado.data,
                    rnt_id: this.dataShared.data.rnt_id,
                    municipio_id: this.dataShared.data.municipio_id,
                  })
                  .subscribe((resultadoNotifica) => {
                    if (resultadoNotifica.result) {
                      const modalFinalizar = this.modalService.open(
                        ModalConfirmacionSolicitudComponent,
                        { centered: true }
                      );
                      modalFinalizar.componentInstance.mensaje =
                        resultadoNotifica.data;
                      modalFinalizar.result
                        .then(() => {
                          this.router.navigate(["/mis-establecimientos"]);
                        })
                        .catch(() => {
                          this.router.navigate(["/mis-establecimientos"]);
                        });
                    }
                  });
              }
            });
        }

        break;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  //#region Reactivacion
  onFileInput(eventFile) {
    const tempo = eventFile.target.files as FileList;
    for (let index = 0; index < tempo.length; index++) {
      const file = tempo.item(index);
      if (this.extensiones.indexOf(file.type) < 0) {
        this.alertService.warn(
          "Solo se permite archivos con extensión .pdf, .jpg, .png, .jpeg",
          "/otra-solicitudes",
          "sin-codigo"
        );
        return false;
      }
      if (file.size / 1024 / 1024 > 10) {
        this.alertService.warn(
          "Ha superado el tamaño máximo permitido (10Mb)",
          "/otra-solicitudes",
          "sin-codigo"
        );
        return false;
      }
    }
    if (!this.datos_adjuntos) {
      this.datos_adjuntos = new Array<DatoAdjuntoModel>();
    }
    for (let index = 0; index < tempo.length; index++) {
      // const reader = new FileReader();
      const file = tempo.item(index);
      this.datos_adjuntos.push({
        nombre: file.name,
        tamano: file.size / 1024,
        medida: "kb",
        porcentaje_cargado: 100,
      } as DatoAdjuntoModel);
      this.otrasSolicitudesService
        .uploadFile({
          ...this.dataShared.data,
          ...this.completaForm.value,
          file_to_upload: file,
        })
        .subscribe(
          (fileProgess) => {
            if (fileProgess.type === HttpEventType.Sent) {
              this.datos_adjuntos[index].porcentaje_cargado = 50;
            } else if (fileProgess.type === HttpEventType.UploadProgress) {
              this.datos_adjuntos[index].porcentaje_cargado = Math.round(
                (100 * fileProgess.loaded) / fileProgess.total
              );
            } else if (fileProgess.type === HttpEventType.Response) {
              if (fileProgess.ok) {
                const resultado = fileProgess.body as ResponseServiceModel;
                if (resultado.result) {
                  this.datos_adjuntos[index] = {
                    ...this.datos_adjuntos[index],
                    nombre: resultado.data.nombre_archivo,
                    ruta_url: resultado.data.ruta_url,
                  };
                  this.alertService.alert(
                    resultado.control.alert_type as AlertType,
                    "Archivo cargado exitosamente.",
                    `/Archivo/SubirDocumento/${this.dataShared.data.codigo_camara}/${this.completaForm.value.detalle_solicitud_id}`,
                    resultado.control.code.toString()
                  );
                }
              }
            }
          },
          (error) => {
            this.datos_adjuntos.splice(index, 1);
          }
        );
    }
  }

  onRemoverFile(datos_adjunto: DatoAdjuntoModel) {
    const pos = this.datos_adjuntos.indexOf(datos_adjunto);
    if (pos > -1) {
      this.otrasSolicitudesService
        .dropUploadFile({
          ...this.dataShared.data,
          ...this.datos_adjuntos[pos],
          ...this.completaForm.value,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.datos_adjuntos.splice(pos, 1);
            this.alertService.alert(
              resultado.control.alert_type as AlertType,
              resultado.control.message,
              `/Archivo/EliminarDocumento/${this.dataShared.data.codigo_camara}/${this.completaForm.value.detalle_solicitud_id}`,
              resultado.control.code.toString()
            );
          }
        });
    }
  }

  onVerDocumento(datos_adjunto: DatoAdjuntoModel) {
    this.otrasSolicitudesService
      .descargarDocumento({
        url: `${datos_adjunto.ruta_url}/${datos_adjunto.nombre}`,
      })
      .subscribe((resultado) => {
        const url = window.URL.createObjectURL(resultado);
        window.open(url);
      });
  }
  //#endregion

  showModalAceptarTermino() {
    this.otrasSolicitudesService
      .getParametro({
        parametro_id: "TEXTO_TRATAMIENTO_DATOS_PASO_SOLICITUD",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.texto_aceptacion_terminos = resultado.data;
          this.otrasSolicitudesService
            .getParametro({
              parametro_id: "TITULO_MODAL_TRATAMIENTO_DATOS_SOLICITUD",
              agrupacion: "TRATAMIENTO_DATOS",
              auxiliar: "1",
            })
            .subscribe((resultado2) => {
              if (resultado2.result) {
                const modalAceptarTerminos = this.modalService.open(
                  ModalAceptarTerminosComponent,
                  { centered: true, backdrop: "static", size: "lg" }
                );
                modalAceptarTerminos.componentInstance.mensaje =
                  this.texto_aceptacion_terminos;
                modalAceptarTerminos.componentInstance.titulo = resultado2.data;
                modalAceptarTerminos.result.then(() => {
                  this.continuarPaso();
                });
              }
            });
        }
      });
  }

  showModalInfoEliminarActividadEconomica() {
    this.otrasSolicitudesService
      .getParametro({
        parametro_id: "INFO_ELIMINAR_ACTIVIDAD_ECONOMICA",
        agrupacion: "TEXTO",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          const modalRef = this.modalService.open(
            ModalInfoEliminarActividadEconomica,
            {
              centered: true,
            }
          );
          const confirmarRespuesta = {} as ConfirmarRespuestaModel;
          confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
          confirmarRespuesta.tipoConfirmacionModalType =
            TipoConfirmacionModalType.Alerta;
          confirmarRespuesta.message = resultado.data;
          confirmarRespuesta.buttonTextAlert = "Continuar";
          modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
          modalRef.result.then(() => {
            this.showModalAceptarTermino();
          });
        }
      });
  }

  //#region Manejo_Textos_Modulo Reactivacion+renovacion

  showsTextReactivacionRenovacion(pago: number, payment_status: string) {
    if ((pago === 1 || pago === 0) && payment_status === "paid") {
      if (
        this.result_pago_fontur.estado_pago_fontur_id === undefined ||
        this.result_pago_fontur.estado_pago_fontur_id === 0
      ) {
        this.result_pago_fontur.estado_pago_fontur_id = 1;
      }
      this.otrasSolicitudesService
        .getParametro({
          parametro_id: "INFORMACION_ASOCIAR_IMAGEN_CONSIGNACION_PAGO",
          agrupacion: "VALIDACIONES",
          auxiliar: "1",
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.Texto_Reactivacion_renovacion1 =
              resultado.data !== ""
                ? resultado.data
                : " * Agregar Titulo descripcion desde el modulo parametro ";
            this.ActivarMensajeConfirmacion();
          }
        });
    } else if ((pago === 2 || pago === 0) && payment_status === "unpaid") {
      if (
        this.result_pago_fontur.estado_pago_fontur_id === undefined ||
        this.result_pago_fontur.estado_pago_fontur_id === 0
      ) {
        this.result_pago_fontur.estado_pago_fontur_id = 2;
      }
      this.otrasSolicitudesService
        .getParametro({
          parametro_id: "INFORMACION_ASOCIAR_IMAGEN_CONSIGNACION_NoPAGO",
          agrupacion: "VALIDACIONES",
          auxiliar: "1",
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.Texto_Reactivacion_renovacion1 =
              resultado.data !== ""
                ? resultado.data
                : " * Agregar Titulo descripcion desde el modulo parametro ";

            this.Texo_Mensaje_estado_fontur =
              this.Texto_Reactivacion_renovacion1;
          }
        });
    } else if (pago === 2 && payment_status === "No_disponible") {

      this.otrasSolicitudesService
      .getParametro({
        parametro_id: "TEXTO_FALLO_SERVICIO_FONTUR",
        agrupacion: "TEXTO",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.Texto_Reactivacion_renovacion1 = resultado.data !== "" ? resultado.data
          : " * Agregar Titulo descripcion desde el modulo parametro ";
        }
      });

    } else {
      this.router.navigate(["/mis-establecimientos"]);
    }
  }

  showsTextReactivacionRenovacion2():void{
        this.otrasSolicitudesService
          .getParametro({
            parametro_id: "INFORMACION_ASOCIAR_IMAGEN_CONSIGNACION",
            agrupacion: "TEXTOS_INTERFAZ",
            auxiliar: "1",
          })
          .subscribe((resultado) => {
            if (resultado.result) {
              this.Texto_Reactivacion_renovacion1 = resultado.data !== "" ? resultado.data: "NO";
            }
          });
          this.result_pago_fontur.estado_pago_fontur_id = 1;
  }


  ActivarMensajeConfirmacion():void{
    this.otrasSolicitudesService
      .getParametro({
        parametro_id: "TEXTO_CONFIRMACION_SERVICIO_PAGO_FONTUR",
        agrupacion: "TEXTO",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.Texo_Mensaje_estado_fontur = resultado.data !== "" ? resultado.data
          : " * Agregar Titulo descripcion desde el modulo parametro ";
        }
      });
}


  //#endregion servicio Pago fontur

  validarPagoFontur(cod_rnt: number,codigo_solitud:number): Promise<AccionesPagoFonturRntEntry> {
    return new Promise((resolve, reject) => {
      const enviar: AccionesPagoFonturRntEntry = {
        code: cod_rnt,
        estado_pago_fontur_id: null,
        payment_status: null,
        solicitud_id:codigo_solitud
      };

      this.otrasSolicitudesService.ValidarPagoFontur(enviar).subscribe(
        (response: ValidarPagoFonturResponse) => {
          this.result_pago_fontur = response.data as AccionesPagoFonturRntEntry;
          resolve(this.result_pago_fontur);
        },
        (error) => {
          // Manejo del error y asignación de valores predeterminados
          this.result_pago_fontur = {
            code: cod_rnt,
            payment_status: "No_disponible",
            estado_pago_fontur_id: 2,
          };
          resolve(this.result_pago_fontur);
        }
      );
    });
  }

// Actualizar pago fontur a db.
  ActualizarEstadoPagoFontur(cod_rnt: number,estado: number,fecha_ultima: string): void {
    this.otrasSolicitudesService
      .UpdatePagoFontur({
        code: cod_rnt,
        estado_pago_fontur_id: estado,
        query_date: fecha_ultima,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.createReactivacionAccion(resultado);
        }
      });
  }

  ValidarOpcionPago(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.otrasSolicitudesService
        .getParametro({
          parametro_id: "ASOCIAR_IMAGEN_CONSIGNACION",
          agrupacion: "VALIDACIONES",
          auxiliar: "1",
        })
        .subscribe(
          (resultado) => {
            if (resultado.result) {
              this.valorFormaPagoFontur = resultado.data.trim() !== "" ? resultado.data.trim().toUpperCase(): " * Agregar Titulo descripcion desde el modulo parametro ";
            }
            resolve();
          },
          (error) => {
            reject(error); // Manejo de errores
          }
        );
    });
  }

  getColor(estado_pago_fontur_id: number | undefined): string {
    if (this.valorFormaPagoFontur === this.paga_manual) {
      return '';  // Sin color especial
    }
    return estado_pago_fontur_id === 1 ? 'green' : estado_pago_fontur_id === 2 ? 'red' : '';
  }

  isPaymentStatusValid(estado_pago_fontur_id: number | undefined): boolean {
    return estado_pago_fontur_id === 1 || estado_pago_fontur_id === 2;
  }

  async metodoAsync() {
    try {
       const resultado =
       await this.solicitudService.get(
        this.dataShared.data
      ).toPromise();

      if (resultado.result) {
        // Devolver para visualización
        // Validar método de pago
        await this.ValidarOpcionPago();

        if (this.valorFormaPagoFontur === this.paga_manual) {
          this.showsTextReactivacionRenovacion2();
        } else {
          this.showsTextReactivacionRenovacion(this.si_pago, "paid");
        }
      }
    } catch (error) {
      console.error('Error al obtener la solicitud', error);
    }
  }
  //#endregion
}
